const maritalStatus = [
  { value: 'married', name: 'Casado(a)' },
  { value: 'divorced', name: 'Divorciado(a)' },
  { value: 'single', name: 'Solteiro(a)' },
  { value: 'widowed', name: 'Viúvo(a)' },
];

export default maritalStatus;
